import { render, staticRenderFns } from "./CursoOnlineBanner.vue?vue&type=template&id=37869887&scoped=true&"
import script from "./CursoOnlineBanner.vue?vue&type=script&lang=js&"
export * from "./CursoOnlineBanner.vue?vue&type=script&lang=js&"
import style0 from "./CursoOnlineBanner.vue?vue&type=style&index=0&id=37869887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37869887",
  null
  
)

export default component.exports